import API, { APIResponse } from '../../../lib/commons/api'
import { UserBasic } from '../../../lib/functions/user'
import { DivisionProps } from '../../../lib/functions/division'
import { IItemDelta } from '../../../domain/value-object/ItemDeltaInputVO'

export const PROGRAM_STATUSES = [
  'STANDBY',
  'INPROGRESS',
  'SUSPENDED',
  'COMPLETED',
] as const

export type ProgramStatus = (typeof PROGRAM_STATUSES)[number]

export type ProgramOverviewDto = {
  uuid: string
  code: string
  displayName: string
  status: ProgramStatus | null
  scheduledStartDate: string | null
  scheduledEndDate: string | null
  division: DivisionProps | null
  programManager: UserBasic
  collaborators: UserBasic[]
  revision: string
  createdAt: number
  createdBy: UserBasic
  updatedAt: number
  updatedBy: UserBasic
  lockVersion: number
}

export const getPrograms = (): Promise<APIResponse> =>
  API.functional.request('GET', '/api/v1/programs', {}, true)

export type ProgramCreateInput = {
  uuid: string
  code?: string
  displayName: string
  status: ProgramStatus
  programManagerUuid: string
  divisionUuid?: string
  scheduledStartDate?: string | null
  scheduledEndDate?: string | null
  collaboratorUuids?: string[]
}

export type ProgramUpdateDeltaInput = {
  uuid: string
  displayName?: IItemDelta<string>
  status?: IItemDelta<ProgramStatus>
  programManagerUuid?: IItemDelta<string>
  divisionUuid?: IItemDelta<string>
  scheduledStartDate?: IItemDelta<string | null>
  scheduledEndDate?: IItemDelta<string | null>
  collaboratorUuids?: IItemDelta<string[]>
}

export type ProgramDeleteInput = {
  uuid: string
}

export type ProgramBatchDeltaInput = {
  added: ProgramCreateInput[]
  edited: ProgramUpdateDeltaInput[]
  deleted: ProgramDeleteInput[]
}

export const updateProgramsBatch = (
  request: ProgramBatchDeltaInput
): Promise<APIResponse> =>
  API.functional.request('POST', '/api/v1/programs/batch', request)
